import React, { forwardRef } from 'react';
import { BoxProps } from '@mui/material';

interface ScrollableContainerProps extends BoxProps {
  height?: string | number;
  padding?: string | number;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}

export const ScrollableContainer = forwardRef<HTMLDivElement, ScrollableContainerProps>(
  (
    { height = '630px', padding = '10px 0px 5px 16px', children, onScroll, style },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        style={{
          height,
          overflowY: 'auto',
          overflowX: 'hidden',
          padding,
          ...style,
        }}
        onScroll={(e) => onScroll?.(e)}
      >
        {children}
      </div>
    );
  },
);

ScrollableContainer.displayName = 'ScrollableContainer';
